import { Box, Flex, Image, Text, type ImageProps } from "@chakra-ui/react";
import rexRealEstateLogo from "assets/a-logo.png";
import { useAgencyBranding } from "contexts/agency-settings-provider";
import { usePortalPath } from "hooks/use-portal-path";

type AgencyLogoProps = {
  imageProps?: Omit<ImageProps, "src" | "alt">;
};

export function AgencyLogo({ imageProps = {} }: AgencyLogoProps) {
  const { agencyName, primaryLogo } = useAgencyBranding();

  const { isTenantPath } = usePortalPath();
  const hasPrimaryLogo = Boolean(primaryLogo);

  // for vendor/landlord portal we just show the logo without the agency name
  if (!isTenantPath) {
    return (
      <Image
        src={primaryLogo ?? rexRealEstateLogo}
        alt={primaryLogo ? "Agency Logo" : "Rex Real Estate"}
        w={"100px"}
        {...imageProps}
      />
    );
  }

  return (
    <Flex align={"center"} gap={"2"}>
      {hasPrimaryLogo ? (
        <Image
          src={primaryLogo}
          alt={"Agency Logo"}
          h={{ base: "40px", lg: "50px" }}
          {...imageProps}
        />
      ) : (
        <Box h={"50px"} w={"auto"} />
      )}

      <Text textTransform={"uppercase"} textStyle={"xl"} color={"white"}>
        {agencyName}
      </Text>
    </Flex>
  );
}
